import { SharedConstants, SharedValidationPatterns } from '../constants';

export class StringUtil {
  public static validateRegularSentence(sentence: string): string {
    const _changedValue = sentence
      .split(SharedConstants.EMPTY_STRING_SPACE)
      .map((_chars) =>
        _chars.replace(
          SharedValidationPatterns.ALPHA_NUMBERIC_PATTERN_MULTI_REGEX,
          SharedConstants.EMPTY_STRING
        )
      )
      .join(SharedConstants.EMPTY_STRING_SPACE);

    return _changedValue.trim();
  }

  /**
   * Will remove white spaces from string
   *
   * @param {string | null | undefined} value
   * @returns string
   */
  public static removeWhiteSpaces(value: string | null | undefined): string {
    if (value && typeof value === 'string') {
      return value.trim();
    } else {
      return '';
    }
  }

  /**
   * Will check string empty or not
   *
   * @param {string | null | undefined} value
   * @returns boolean
   */
  public static isEmpty(value: string): boolean {
    return value === '' || value === undefined || value === null;
  }

  /**
   * a method to slice and format a string to an other string
   * @param {string} value a string need to removed
   * @param {string[]} removedString a string to compare and remove in value
   * @returns string
   */
  public static sliceString(value: string, ...removedString: string[]): string {
    let result = value;

    removedString.map((removed: string) => {
      if (!result.includes(removed)) {
        return;
      }

      let i = 0;
      let j = 0; // J is index of removed item
      let isEqual = true;

      while (i < result.length) {
        const _charAt = result.charAt(i);

        if (j === 0) {
          isEqual === true;
        }

        if (_charAt !== removed.charAt(j)) {
          i++;
          j = 0;
          isEqual = false;
          continue;
        }

        // Matched to remove
        if (j === removed.length - 1 && isEqual === true) {
          if (i - j === 0) {
            result = result.slice(j + 1, result.length);
          } else {
            result = `${result.slice(0, i - j)}${result.slice(j + 1, result.length)}`;
          }
        }

        i++;
        j++;
      }
    });

    return result;
  }

  /**
   * symbol formatter is a function format and return the value and symbol
   * @param {string | number} value
   * @param { Symbol } symbol
   * @param { string } defaultEmpty
   */
  public static symbolFormatter(
    value: string | number,
    symbol: string,
    defaultEmpty: string = SharedConstants.EMPTY_DASH_STRING
  ): string {
    if (!value) {
      return defaultEmpty;
    }

    return `${value}${symbol}`;
  }
}
